import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { PRODUCT_TILE_FIRST_ITERATION_250506 } from "@faire/web-api--source/indigofair/settings/PRODUCT_TILE_FIRST_ITERATION_250506";

export const useSettingProductTileIteration = (): IThreeVariantXP.Bucket =>
  useSetting(
    PRODUCT_TILE_FIRST_ITERATION_250506,
    IThreeVariantXP.Bucket.CONTROL
  ) as IThreeVariantXP.Bucket;

export const useSettingProductTileIterationInTreatment = (): boolean => {
  const settingValue = useSettingProductTileIteration();
  return (
    settingValue === IThreeVariantXP.Bucket.VARIANT_2 ||
    settingValue === IThreeVariantXP.Bucket.VARIANT_3
  );
};
